export const MODE = {
  NEW: 'new',
  EDIT: 'edit',
  VIEW: 'view',
};

export const validMode = (mode = '') => {
  return Object.values(MODE).includes(mode);
};
